var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"highlightpoint"},[_c('div',{staticClass:"round_icon",style:(_vm.icon_style)},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }